import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import {
  getCampaignLandingData,
  getCampaignElements,
  getReadyToSubmit,
  getIsSubmittingForProcessing,
  submitCampaignSubmission,
  getIsCampaignPreview,
  previewSubmitCampaignSubmission,
  getCampaignBanner,
  getUseCampaignBanner,
  getCampaignBrandFontColor
} from '../../redux/modules/campaignLandingPage';
import styles from './SubmitResponseButton.module.less';
import { useVpSnackbar } from '../../vp-ui';
import { StyledBrandingButton } from './styles';

const buildPayload = (campaignLandingData, campaignElements) => {
  const elementsAsArray = Object.values(campaignElements);

  return {
    campaignId: campaignLandingData.campaignId,
    responses: elementsAsArray.map((el) => ({
      campaignElementId: el.id,
      value: el.value,
      mediaSubmissionId: el.preSignedUrlData?.mediaSubmissionId,
      selected: el.selected,
      attachment: el?.attachment
    }))
  };
};

const SubmitResponseButton = ({
  _submitCampaignSubmission,
  readyToSubmit,
  campaignLandingData,
  campaignElements,
  isSubmittingForProcessing,
  isPreview,
  _previewSubmitCampaignSubmission,
  backgroundColor = '',
  color = '',
  useBanner = false
}) => {
  const { addSnackbar } = useVpSnackbar();

  const handleSubmit = () => {
    if (isPreview) {
      _previewSubmitCampaignSubmission();

      addSnackbar({
        severity: 'warning',
        title: 'No Submission',
        message: `No submission has been sent because this is a preview of your Campaign. You can find the correct link under Share -> Copy Campaign Link, on your Campaign's editing page.`
      });
    } else {
      const payload = buildPayload(campaignLandingData, campaignElements);
      _submitCampaignSubmission(payload);
    }
  };

  const useCustomeStyle = useBanner && backgroundColor && color;

  return (
    <StyledBrandingButton
      variant="contained"
      disabled={!isPreview && !readyToSubmit}
      id="vpSubmitResponseButton"
      data-testid="submitResponse"
      backgroundColor={backgroundColor}
      fontColor={color}
      custom={useCustomeStyle}
      onClick={handleSubmit}
      sx={{ width: '200px', mt: '25px' }}
    >
      {isSubmittingForProcessing ? <Loader className={styles.vpLoadingSpinner} /> : 'Submit'}
    </StyledBrandingButton>
  );
};

SubmitResponseButton.propTypes = {
  _submitCampaignSubmission: PropTypes.func,
  readyToSubmit: PropTypes.bool,
  campaignLandingData: PropTypes.object,
  campaignElements: PropTypes.object,
  isSubmittingForProcessing: PropTypes.bool,
  isPreview: PropTypes.bool,
  _previewSubmitCampaignSubmission: PropTypes.func,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  useBanner: PropTypes.bool
};

const mapStateToProps = (state) => ({
  readyToSubmit: getReadyToSubmit(state),
  campaignLandingData: getCampaignLandingData(state),
  campaignElements: getCampaignElements(state),
  isSubmittingForProcessing: getIsSubmittingForProcessing(state),
  isPreview: getIsCampaignPreview(state),
  backgroundColor: getCampaignBanner(state),
  useBanner: getUseCampaignBanner(state),
  color: getCampaignBrandFontColor(state)
});

const mapDispatchToProps = {
  _submitCampaignSubmission: submitCampaignSubmission,
  _previewSubmitCampaignSubmission: previewSubmitCampaignSubmission
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitResponseButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/SubmitResponseButton.jsx